import API, { isExpiredToken } from 'utils/api';

export const checkToken = async () => {
  try {
    if (isExpiredToken()) {
      await API.get('/catalogos/estados-globales/');
    }
  } catch (err) {
    // El interceptor de utils/api.js ya maneja el refresh/logout; aquí solo
    // dejamos rastro para diagnóstico.
    // eslint-disable-next-line no-console
    console.error('[checkToken] error al forzar la renovación del token', err);
  }
};

export default { checkToken };
